import { AppointmentInfo } from "./AppointmentInfo";

export class RoomQueryParameters {
  buildingId: string = "";
  floorId: string = "";
  arrangeTypeId: string = "";
  capacity: number | null = null;
  attributes: string[] = [];
  appointmentInfo: AppointmentInfo | null = null;

  constructor(initializer?: any) {
    if (!initializer) return;

    if (initializer.buildingId) this.buildingId = initializer.buildingId;
    if (initializer.floorId) this.floorId = initializer.floorId;
    if (initializer.arrangeTypeId) this.arrangeTypeId = initializer.arrangeTypeId;
    if (initializer.capacity) this.capacity = initializer.capacity;
    if (initializer.attributes) this.attributes = initializer.attributes;
    if (initializer.appointmentInfo) this.appointmentInfo = initializer.appointmentInfo;
  }

  toUrlParams(): string {
    let params = "?require_mailbox";
    if (this.buildingId != "") {
      params += `&bl_id=${this.buildingId}`;
    }
    if (this.floorId != "") {
      params += `&fl_id=${this.floorId}`;
    }
    if (this.arrangeTypeId != "") {
      params += `&rm_arrange_type_id=${this.arrangeTypeId}`;
    }
    if (this.capacity != null) {
      params += `&capacity=${this.capacity}`;
    }
    if (this.attributes != null && this.attributes.length > 0) {
      params += `&attributes=${this.attributes}`;
    }
    if (this.appointmentInfo != null) {
      params += this.appointmentInfo.toUrlParams();
    }
    return params;
  }
}
